import ImageGalleryIslandBays from "./ImageGalleryIslandBays";
export default ImageGalleryIslandBays;
